import { FormControl, FormGroup, Validators } from '@angular/forms';

export function buildForm() {
  const form = new FormGroup({
    comment: new FormControl(null, [
      Validators.required,
      Validators.maxLength(1000),
    ]),
  });
  return form;
}
